module.exports = __webpack_public_path__ + "d20c6953cf527eb78ce33ab4a476df5f.svg";